<template>
  <div id="app">
    <!-- 弹窗提示组件 -->
    <unified-pop v-if="user && user.type && user.type == 2"></unified-pop>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {
    unifiedPop: resolve => import('@/components/family/popupTips/unifiedPop')
  },
  name: "App",
  data() {
    return {
      key: new Date().getTime(),
      innerHeight: window.innerHeight
    };
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    // 监听键盘
    onResize(e) {
      this.abc = JSON.stringify(e)
      const height = window.innerHeight // 获取窗口高度
      const keyHeight = Math.abs(height - this.innerHeight) 
      this.innerHeight = height
      // 将键盘高度存储到Vuex中，方便全局调用
      this.$store.dispatch('common/setKeyboardHeight', keyHeight)
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*ios禁止微信字体大小*/
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
html {
  font-size: 20px;
  /*max-width: 420px;*/
  margin: auto;
}
.clear {
  clear: both;
}
.pointer {
  cursor: pointer;
}
// 导航背景颜色、字体颜色更改
.van-nav-bar {
  background: $background_color !important;
  .van-icon {
    color: white !important;
  }
  .van-nav-bar__title {
    color: white !important;
  }
  .van-nav-bar__right {
    color: white !important;
  }
  .van-nav-bar__text {
    color: white !important;
  }
}
.van-nav-bar-family {
  background: $family_color !important;
}

//下划线
.line{ 
  height:1px;border:none;border-top:1px dashed #040404;
}

// 页面动画
.fade-enter,
.fade-leave-to {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
  height: 100vh;
  width: 100vw;
}
.fade-enter-to,
.fade-leave {
  transform: translateX(0%);
  -webkit-transform: translateX(00%);
  height: 100vh;
  width: 100vw;
}
.fade-enter-active,
.fade-leave-active {
  transition: 300ms;
  -webkit-transition: 300ms;
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}
.flex-around {
  display: flex;
  justify-content: space-around;
}

.popup-top-menu {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  font-size: 0.8rem;
  > span:first-child {
    color: #969696;
  }
  > span:last-child {
    color: #ff5b5f;
  }
}

// 长者护理选择宽度设置
.nursing-select-item{
  width: 50vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue